// extracted by mini-css-extract-plugin
export default {"wrapper":"layout_wrapper__tw2VC","content":"layout_content__0BYzf","display":"layout_display__1HJJw","hide":"layout_hide__Jo5lN"};